import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {TerraceTypeEnum} from "@/modules/stadium/enums";
import {Min} from "class-validator";
import {Stadium} from "@/modules/stadium/entity/Stadium";

@Entity({orderBy: {id: 'ASC'}})
export class Terrace extends BaseEntity {
  @ManyToOne(() => Stadium, r => r.terraces)
  stadium: Relation<Stadium>;

  @Column({type: 'varchar', enum: TerraceTypeEnum})
  type: TerraceTypeEnum;

  @Column({type: 'boolean'})
  available = false;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  seats: number;

  @Column({type: 'integer', unsigned: true})
  @Min(0)
  seatsLimit: number;

  @Column({type: 'integer', unsigned: true, nullable: true})
  @Min(0)
  seatsTarget?: number | null;

  @Column({type: 'date', nullable: true})
  seatsFinishedAt?: Date | null;

  @Column({type: 'integer', unsigned: true, nullable: true})
  @Min(0)
  entranceFee = 0;
}
